module.exports = __webpack_public_path__ + "static/media/hufflepuff-2019.0342127b.png";